// feat/gemiste-taken: taken van eerdere dagen die open bleven, alsnog afvinken of overslaan
// (Taken in de ouderapp). Sinds fix/taken-per-dag staan ze niet meer op het bord of in Vandaag.
export const appMissedNl = {
    /** Regel bovenaan Taken; alleen als er iets gemist is. */
    line: {
        one: '{count} taak gemist in de afgelopen week',
        other: '{count} taken gemist in de afgelopen week',
    },
    lineSub: 'Alsnog afvinken of overslaan',
    open: 'Bekijken',
    title: 'Gemist',
    description: 'Taken van de afgelopen week die open bleven. Vink ze alsnog af of sla ze over. Punten tellen zoals op die dag.',
    done: 'Alsnog gedaan',
    doneLabel: 'Alsnog gedaan: {title}, {name}',
    skip: 'Overslaan',
    skipLabel: 'Overslaan: {title}, {name}',
    undo: 'Ongedaan maken',
    undoLabel: 'Ongedaan maken: {title}, {name}',
    markedDone: '{title} alsnog afgevinkt',
    markedSkipped: '{title} overgeslagen',
    undone: '{title} staat weer bij gemist',
    stateDone: 'Gedaan',
    stateSkipped: 'Overgeslagen',
    allDone: 'Niets meer gemist. Alles is bijgewerkt.',
};
//# sourceMappingURL=missedApp.nl.js.map